<template>
  <div class="a-analysis" v-if="subjectList.length>0">
    <div class="a-header">
      <div class="a-distribute">
        <span class="title">学习时间分布</span>
        <div class="subject-charts">
          <div class="subject-bg">
            <p class="test-num">各科学习时间分布</p>
            <p class="test-total" v-html="formatSecToStr"></p>
            <div class="time-detail"></div>
          </div>
        </div>
      </div>
      <div class="a-distribute">
        <span class="title">答题数分布</span>
        <div class="subject-charts">
          <div class="subject-bg">
            <p class="test-num">答题总数</p>
            <p class="test-total">{{total_question_num}}<span>道</span> </p>
            <div class="question-detail"></div>
          </div>
        </div>
      </div>
    </div>
    <adaptive-learn
    :account_id="account_id"
    :class_id="class_id"
    :school_id="school_id"
    :school_master_class_id="school_master_class_id"
    :subjectList="subjectList"
    />
  </div>
  <Empty content="学生暂无智适应学习数据~" type="1" v-else/>
</template>

<script>
import * as echarts from 'echarts';
import AdaptiveLearn from './adaptive-learn.vue';
import { studentLearningSituation } from '@/api/pt';
import Empty from './empty.vue';

export default {
  name: 'AdaptiveAnalysis',
  data() {
    return {
      value: '',
      options: [],
      colorOne: '',
      colorTwo: '',
      total_question_num: 0, // 总测评次数
      total_time: 0, // 总时间
      index: 0, // 下标
      subjectList: [
        {
          subject_id: 3,
          subject_name: '语文',
        },
        {
          subject_id: 2,
          subject_name: '数学',
        },
        {
          subject_id: 1,
          subject_name: '英语',
        },
        {
          subject_id: 4,
          subject_name: '物理',
        },
        {
          subject_id: 5,
          subject_name: '化学',
        },
        {
          subject_id: 6,
          subject_name: '生物',
        },
      ],
      questionDetail: [], // 题目详情
      timeDetail: [], // 学习时长详情
    };
  },
  props: ['account_id', 'class_id', 'school_id', 'school_master_class_id'],
  components: { AdaptiveLearn, Empty },
  mounted() {
    this.studentLearningSituation();
  },
  computed: {
    formatSecToStr() {
      const daySec = 24 * 60 * 60;
      const hourSec = 60 * 60;
      const minuteSec = 60;
      const dd = Math.floor(this.total_time / daySec);
      const hh = Math.floor((this.total_time % daySec) / hourSec);
      const mm = Math.floor((this.total_time % hourSec) / minuteSec);
      const ss = this.total_time % minuteSec;
      if (dd > 0) {
        return `${dd}<span style="font-size:16px">天</span>${hh}<span style="font-size:16px">小时</span>`;
      } if (hh > 0) {
        return `${hh}<span style="font-size:16px">小时</span>${mm}<span style="font-size:16px">分钟</span>`;
      } if (mm > 0) {
        return `${mm}<span style="font-size:16px">分钟</span>${ss}<span style="font-size:16px">秒</span>`;
      }
      return `${ss}<span style="font-size:16px">秒</span>`;
    },
    arrList() {
      const arr = [];
      this.questionDetail.forEach((item) => {
        if (item.subject_id === 2) {
          this.colorOne = '#3DE974';
          this.colorTwo = '#38EB78';
        } else if (item.subject_id === 4) {
          this.colorOne = '#4FF3FF';
          this.colorTwo = '#64ECD4';
        } else if (item.subject_id === 1) {
          this.colorOne = '#FFF13B';
          this.colorTwo = '#FBEC50';
        } else if (item.subject_id === 3) {
          this.colorOne = '#FFA358';
          this.colorTwo = '#FFDA73';
        } else if (item.subject_id === 5) {
          this.colorOne = '#A472FF';
          this.colorTwo = '#8B9EFF';
        } else {
          this.colorOne = '#00F1FF';
          this.colorTwo = '#8A4FFF';
        }
        arr.push({
          value: item.question_num,
          name: item.subject_name,
          percentage: item.percentage,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                offset: 0,
                color: this.colorOne,
              }, {
                offset: 1,
                color: this.colorTwo,
              }]),
            },
          },
        });
      });
      return arr;
    },
    timeList() {
      const arr = [];
      this.timeDetail.forEach((item) => {
        if (item.subject_id === 2) {
          this.colorOne = '#3DE974';
          this.colorTwo = '#38EB78';
        } else if (item.subject_id === 4) {
          this.colorOne = '#4FF3FF';
          this.colorTwo = '#64ECD4';
        } else if (item.subject_id === 1) {
          this.colorOne = '#FFF13B';
          this.colorTwo = '#FBEC50';
        } else if (item.subject_id === 3) {
          this.colorOne = '#FFA358';
          this.colorTwo = '#FFDA73';
        } else if (item.subject_id === 5) {
          this.colorOne = '#A472FF';
          this.colorTwo = '#8B9EFF';
        } else {
          this.colorOne = '#00F1FF';
          this.colorTwo = '#8A4FFF';
        }
        arr.push({
          value: item.time,
          name: item.subject_name,
          percentage: item.percentage,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [{
                offset: 0,
                color: this.colorOne,
              }, {
                offset: 1,
                color: this.colorTwo,
              }]),
            },
          },
        });
      });
      return arr;
    },
  },
  methods: {
    initQuestion() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.question-detail'));
      // 绘制图表
      const that = this;
      myChart.setOption({
        tooltip: {
          trigger: 'item',
        },
        legend: {
          x: '20%',
          y: '80%',
          // orient: 'vertical',
          icon: 'circle',
          textStyle: {
            color: '#303133',
            fontSize: 14,
          },
          formatter(val) {
            const { arrList } = that;
            arrList.forEach((v, i) => {
              if (v.name === val) {
                that.index = i;
              }
            });
            return `${val} | ${arrList[that.index].value}道  ${arrList[that.index].percentage}%`;
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['32%', '42%'],
            center: ['50%', '50%'],
            labelLine: {
              length: 25,
              length2: 40,
            },
            label: {
              normal: {
                show: true,
                formatter(params) {
                  // 自定义颜色
                  const res = `{value|${params.data.percentage}%}`;
                  return res;
                },
                rich: {
                  value: {
                    fontFamily: 'PingFangSC-Semibold, PingFang SC',
                    fontSize: 14,
                    color: '#303133',
                  },
                },
              },
            },
            data: this.arrList,
            // itemStyle: {
            //   borderColor: '#263180',
            // borderWidth: 10,
            // },
          },
        ],
      });
    },
    initTime() {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(document.querySelector('.time-detail'));
      // 绘制图表
      const that = this;
      myChart.setOption({
        tooltip: {
          trigger: 'item',
        },
        legend: {
          x: '20%',
          y: '80%',
          // orient: 'vertical',
          icon: 'circle',
          textStyle: {
            color: '#303133',
            fontSize: 14,
          },
          formatter(val) {
            const { timeList } = that;
            timeList.forEach((v, i) => {
              if (v.name === val) {
                that.index = i;
              }
            });
            return `${val} | ${Math.floor(timeList[that.index].value / 60)}分钟  ${timeList[that.index].percentage}%`;
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['32%', '42%'],
            center: ['50%', '50%'],
            labelLine: {
              length: 25,
              length2: 40,
            },
            label: {
              normal: {
                show: true,
                formatter(params) {
                  // console.log(params, 'params');
                  // 自定义颜色
                  const res = `{value|${params.data.percentage}%}`;
                  return res;
                },
                rich: {
                  value: {
                    fontFamily: 'PingFangSC-Semibold, PingFang SC',
                    fontSize: 14,
                    color: '#303133',
                  },
                },
              },
            },
            data: this.timeList,
            // itemStyle: {
            //   borderColor: '#263180',
            // borderWidth: 10,
            // },
          },
        ],
      });
    },
    async studentLearningSituation() {
      const params = {
        account_id: this.account_id,
        school_id: this.school_id,
      };
      const res = await studentLearningSituation(params);
      this.total_question_num = res.data.total_question_num;
      this.total_time = res.data.total_time;
      // this.subjectList = res.data.subject_list;
      this.questionDetail = res.data.question_detail;
      this.timeDetail = res.data.time_detail;
      if (this.questionDetail.length > 0) {
        const newPromise = new Promise((resolve) => {
          resolve();
        });
        newPromise.then(() => {
          this.initQuestion();
        });
      }
      if (this.timeDetail.length > 0) {
        const newPromise = new Promise((resolve) => {
          resolve();
        });
        newPromise.then(() => {
          this.initTime();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.a-analysis{
  margin-top: 39px;
  .a-header{
    display: flex;
    justify-content: space-around;
    .a-distribute{
     width: 500px;
     height: 500px;
     position: relative;
    //  margin-left: 50px;
   .title{
     position: absolute;
     top: 2%;
     left: 40%;
     transform: translatea(-50%,-50%);
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8);
      position: relative;
      &::before{
        content: '';
        position: absolute;
        width: 100%;
        height: 13px;
        background: rgba(60, 194, 230, 0.18);
        border-radius: 7px;
        left: 0;
        bottom: 3px;
      }
   }
   .subject-charts{
     position: absolute;
     top: 40%;
     left: 50%;
     transform: translate(-50%,-50%);
     .subject-bg{
        width: 248px;
        height: 248px;
        border-radius:50% ;
        background:#F1F7FF;
        position: relative;
        .question-detail{
          width: 500px;
          height: 500px;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
        .time-detail{
          width: 500px;
          height: 500px;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
        }
        .test-num{
          position: absolute;
          top: 43%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.6);
        }
        .test-total{
          position: absolute;
          top: 60%;
          left: 50%;
          transform: translate(-50%,-50%);
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.6);
          span{
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.6);
          }
        }
     }
   }
  }
  }
}
</style>
